export const brands = [
    {
        id: "imred",
        logo: "/img/brands/imred/homepage/logo.png",
        bgImage: "/img/brands/imred/swiper/background.png",
        fgImage: "/img/brands/imred/swiper/foreground.png",
        thumbnail: "/img/brands/imred/swiper/thumbnail.png",
        title: { text: "imredSeries", color: "#e22a12" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "잘익은 ", color: "black" },
            { text: "과일의 ", color: "black" },
            { text: "풍미", color: "black" }
        ],
        content: "imredContent",
        mainImage: "/img/brands/imred/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/imred/homepage/products/cherry/product.png",
                detail: "/img/brands/imred/homepage/products/cherry/detail.jpg",
                title: "앵두",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/imred/homepage/products/cherry/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/imred/homepage/products/cranberry/product.png",
                detail: "/img/brands/imred/homepage/products/cranberry/detail.jpg",
                title: "크렌베리",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/imred/homepage/products/cranberry/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/imred/homepage/products/grapeFruit/product.png",
                detail: "/img/brands/imred/homepage/products/grapeFruit/detail.jpg",
                title: "자몽",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/imred/homepage/products/grapeFruit/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/imred/homepage/products/redTang/product.png",
                detail: "/img/brands/imred/homepage/products/redTang/detail.jpg",
                title: "레드향",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/imred/homepage/products/redTang/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/imred/homepage/products/strawKiwi/product.png",
                detail: "/img/brands/imred/homepage/products/strawKiwi/detail.jpg",
                title: "스트로키위",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/imred/homepage/products/strawKiwi/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            }
        ]
    },
    {
        id: "cactus",
        logo: "/img/brands/cactus/homepage/logo.png",
        bgImage: "/img/brands/cactus/swiper/background.jpg",
        fgImage: "/img/brands/cactus/swiper/foreground.png",
        thumbnail: "/img/brands/cactus/swiper/thumbnail.png",
        title: { text: "cactusSeries", color: "#075c3d" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "새롭게 ", color: "black" },
            { text: "맛있게 ", color: "black" },
            { text: "물리지 않게", color: "black" }
        ],
        content: "cactusContent",
        mainImage: "/img/brands/cactus/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/cactus/homepage/products/alotus/product.png",
                detail: "/img/brands/cactus/homepage/products/alotus/detail.jpg",
                title: "알로에 선인장",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/cactus/homepage/products/alotus/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/cactus/homepage/products/cactus/product.png",
                detail: "/img/brands/cactus/homepage/products/cactus/detail.jpg",
                title: "선인장",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/cactus/homepage/products/cactus/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/cactus/homepage/products/soltus/product.png",
                detail: "/img/brands/cactus/homepage/products/soltus/detail.jpg",
                title: "솔잎 선인장",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/cactus/homepage/products/soltus/part1.png", top: 9, left: 0, width: 100 },
                    
                ]
            },
        ]
    },
    {
        id: "kaya",
        logo: "/img/brands/kaya/homepage/logo.png",
        bgImage: "/img/brands/kaya/swiper/background.jpg",
        fgImage: "/img/brands/kaya/swiper/foreground.png",
        thumbnail: "/img/brands/kaya/swiper/thumbnail.png",
        title: { text: "kayaSeries", color: "#f51c95" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "새롭게 ", color: "black" },
            { text: "맛있게 ", color: "black" },
            { text: "물리지 않게", color: "black" }
        ],
        content: "kayaContent",
        mainImage: "/img/brands/kaya/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/kaya/homepage/products/energyDrink/product.png",
                detail: "/img/brands/kaya/homepage/products/energyDrink/detail.jpg",
                title: "에너지드링크",
                backgroundColor: "#facaca",
                parts: [
                    { image: "/img/brands/kaya/homepage/products/energyDrink/part1.png", top: -10, left: 10, width: 70 },
                    
                ]
            },
            {
                image: "/img/brands/kaya/homepage/products/lemonDragonFruit/product.png",
                detail: "/img/brands/kaya/homepage/products/lemonDragonFruit/detail.jpg",
                title: "레몬용과",
                backgroundColor: "#fff9b9",
                parts: [
                    { image: "/img/brands/kaya/homepage/products/lemonDragonFruit/part1.png", top: 20, left: 2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/kaya/homepage/products/mojito/product.png",
                detail: "/img/brands/kaya/homepage/products/mojito/detail.jpg",
                title: "모히또",
                backgroundColor: "#cbe57c",
                parts: [
                    { image: "/img/brands/kaya/homepage/products/mojito/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
        ]
    },
    {
        id: "milkfoam",
        logo: "/img/brands/milkfoam/homepage/logo.png",
        bgImage: "/img/brands/milkfoam/swiper/background.jpg",
        fgImage: "/img/brands/milkfoam/swiper/foreground.png",
        thumbnail: "/img/brands/milkfoam/swiper/thumbnail.png",
        title: { text: "milkFoamSeries", color: "#ede3f9" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "우유의 ", color: "black" },
            { text: "부드러움을 ", color: "black" },
            { text: "담은", color: "black" }
        ],
        content: "milkFoamContent",
        mainImage: "/img/brands/milkfoam/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/milkfoam/homepage/products/caramelMilk/product.png",
                detail: "/img/brands/milkfoam/homepage/products/caramelMilk/detail.jpg",
                title: "치즈타로",
                backgroundColor: "#f2d8ff",
                parts: [
                    { image: "/img/brands/milkfoam/homepage/products/caramelMilk/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/milkfoam/homepage/products/cheeseMilkTaro/product.png",
                detail: "/img/brands/milkfoam/homepage/products/cheeseMilkTaro/detail.jpg",
                title: "캬라멜",
                backgroundColor: "#fff9b9",
                parts: [
                    { image: "/img/brands/milkfoam/homepage/products/cheeseMilkTaro/part1.png", top: 10, left: -2, width: 100 },
                    
                ]
            }
        ]
    },
    {
        id: "maxcoolmod",
        logo: "/img/brands/maxcoolmod/homepage/logo.png",
        bgImage: "/img/brands/maxcoolmod/swiper/background.jpg",
        fgImage: "/img/brands/maxcoolmod/swiper/foreground.png",
        thumbnail: "/img/brands/maxcoolmod/swiper/thumbnail.png",
        title: { text: "maxcoolModSeries", color: "#f51c95" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "국내 유일 ", color: "black" },
            { text: "쿨링제와 ", color: "black" },
            { text: "독자개발 스위트너로 퀄리티", color: "black" },
            { text: "MAX", color: "#f51c95" },
        ],
        content: "maxcoolModContent",
        mainImage: "/img/brands/maxcoolmod/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/maxcoolmod/homepage/products/grapeCurrant/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/grapeCurrant/detail.jpg",
                title: "그레이프커런트",
                backgroundColor: "#f2d8ff",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/grapeCurrant/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/lemon/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/lemon/detail.jpg",
                title: "레몬",
                backgroundColor: "#fff9b9",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/lemon/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/soda/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/soda/detail.jpg",
                title: "소다",
                backgroundColor: "#edffff",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/soda/part1.png", top: 10, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/coolBerry/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/coolBerry/detail.jpg",
                title: "쿨베리",
                backgroundColor: "#ffe5f2",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/coolBerry/part1.png", top: 30, left: -4, width: 105 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/pocari/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/pocari/detail.jpg",
                title: "포카리",
                backgroundColor: "#3a69ed",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/pocari/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/plum/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/plum/detail.jpg",
                title: "플럼",
                backgroundColor: "#ffcbcb",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/plum/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/shineMuscat/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/shineMuscat/detail.jpg",
                title: "샤인머스켓",
                backgroundColor: "#e8ffe4",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/shineMuscat/part1.png", top: 15, left: -7, width: 120 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/redGrape/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/redGrape/detail.jpg",
                title: "레드 그레이프",
                backgroundColor: "#fce5ff",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/redGrape/part1.png", top: 15, left: -2, width: 115 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/rich/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/rich/detail.jpg",
                title: "리치",
                backgroundColor: "#edbdbd",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/rich/part1.png", top: 20, left: 1, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcoolmod/homepage/products/yuja/product.png",
                detail: "/img/brands/maxcoolmod/homepage/products/yuja/detail.jpg",
                title: "유자",
                backgroundColor: "#ffe7b9",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/yuja/part1.png", top: 10, left: -9, width: 115 },
                    
                ]
            },
            
        ]
    },
    {
        id: "maxcool",
        logo: "/img/brands/maxcool/homepage/logo.png",
        bgImage: "/img/brands/maxcool/swiper/background.jpg",
        fgImage: "/img/brands/maxcool/swiper/foreground.png",
        thumbnail: "/img/brands/maxcool/swiper/thumbnail.png",
        title: { text: "maxcoolSeries", color: "#f51c95" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "국내 유일 ", color: "black" },
            { text: "쿨링제와 ", color: "black" },
            { text: "독자개발 스위트너로 퀄리티", color: "black" },
            { text: "MAX", color: "#f51c95" },
        ],
        content: "maxcoolContent",
        mainImage: "/img/brands/maxcool/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/maxcool/homepage/products/grapeCurrant/product.png",
                detail: "/img/brands/maxcool/homepage/products/grapeCurrant/detail.jpg",
                title: "그레이프커런트",
                backgroundColor: "#f2d8ff",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/grapeCurrant/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/lemon/product.png",
                detail: "/img/brands/maxcool/homepage/products/lemon/detail.jpg",
                title: "레몬",
                backgroundColor: "#fff9b9",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/lemon/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/soda/product.png",
                detail: "/img/brands/maxcool/homepage/products/soda/detail.jpg",
                title: "소다",
                backgroundColor: "#edffff",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/soda/part1.png", top: 10, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/coolBerry/product.png",
                detail: "/img/brands/maxcool/homepage/products/coolBerry/detail.jpg",
                title: "쿨베리",
                backgroundColor: "#ffe5f2",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/coolBerry/part1.png", top: 30, left: -4, width: 105 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/pocari/product.png",
                detail: "/img/brands/maxcool/homepage/products/pocari/detail.jpg",
                title: "포카리",
                backgroundColor: "#3a69ed",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/pocari/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/plum/product.png",
                detail: "/img/brands/maxcool/homepage/products/plum/detail.jpg",
                title: "플럼",
                backgroundColor: "#ffcbcb",
                parts: [
                    { image: "/img/brands/maxcool/homepage/products/plum/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/shineMuscat/product.png",
                detail: "/img/brands/maxcool/homepage/products/shineMuscat/detail.jpg",
                title: "샤인머스켓",
                backgroundColor: "#e8ffe4",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/shineMuscat/part1.png", top: 30, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/redGrape/product.png",
                detail: "/img/brands/maxcool/homepage/products/redGrape/detail.jpg",
                title: "레드 그레이프",
                backgroundColor: "#fce5ff",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/redGrape/part1.png", top: 30, left: 3, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/rich/product.png",
                detail: "/img/brands/maxcool/homepage/products/rich/detail.jpg",
                title: "리치",
                backgroundColor: "#edbdbd",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/rich/part1.png", top: 25, left: -2, width: 100 },
                    
                ]
            },
            {
                image: "/img/brands/maxcool/homepage/products/yuja/product.png",
                detail: "/img/brands/maxcool/homepage/products/yuja/detail.jpg",
                title: "유자",
                backgroundColor: "#ffe7b9",
                parts: [
                    { image: "/img/brands/maxcoolmod/homepage/products/yuja/part1.png", top: 20, left: -2, width: 100 },
                    
                ]
            }
        ]
    },
    {
        id: "meokgusipo_ice",
        logo: "/img/brands/meokgusipo_ice/homepage/logo.png",
        bgImage: "/img/brands/meokgusipo_ice/swiper/background.png",
        fgImage: "/img/brands/meokgusipo_ice/swiper/foreground.png",
        thumbnail: "/img/brands/meokgusipo_ice/swiper/thumbnail.png",
        title: { text: "ICYSeries", color: "#69b9ff" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "입맛도는 ", color: "black" },
            { text: "상큼함", color: "#69b9ff" },
            { text: "과 강력해진 ", color: "black" },
            { text: "쿨링감", color: "#69b9ff" },
        ],
        content: "sweetAndRefreshingFruits",
        mainImage: "/img/brands/meokgusipo_ice/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/meokgusipo_ice/homepage/products/soda/product.png",
                detail: "/img/brands/meokgusipo_ice/homepage/products/soda/detail.jpg",
                title: "소다",
                backgroundColor: "#cee8ff",
                parts: [
                    { image: "/img/brands/meokgusipo_ice/homepage/products/soda/part1.png", top: 20, left: -7, width: 50 },
                    { image: "/img/brands/meokgusipo_ice/homepage/products/soda/part2.png", bottom: 0, left: 55, width: 50 },
                ]
            },
            {
                image: "/img/brands/meokgusipo_ice/homepage/products/greengrape/product.png",
                detail: "/img/brands/meokgusipo_ice/homepage/products/greengrape/detail.jpg",
                title: "청포도",
                backgroundColor: "#dfffe1",
                parts: [
                    { image: "/img/brands/meokgusipo_ice/homepage/products/greengrape/part1.png", top: 20, left: -7, width: 50 },
                    { image: "/img/brands/meokgusipo_ice/homepage/products/greengrape/part2.png", bottom: 0, left: 58, width: 40 },
                ]
            },
            {
                image: "/img/brands/meokgusipo_ice/homepage/products/lemon/product.png",
                detail: "/img/brands/meokgusipo_ice/homepage/products/lemon/detail.jpg",
                title: "레몬",
                backgroundColor: "#fff8a5",
                parts: [
                    { image: "/img/brands/meokgusipo_ice/homepage/products/lemon/part1.png", top: 20, left: -7, width: 50 },
                    { image: "/img/brands/meokgusipo_ice/homepage/products/lemon/part2.png", bottom: 0, left: 55, width: 50 },
                ]
            },
            {
                image: "/img/brands/meokgusipo_ice/homepage/products/peach/product.png",
                detail: "/img/brands/meokgusipo_ice/homepage/products/peach/detail.jpg",
                title: "복숭아",
                backgroundColor: "#ffe7e7",
                parts: [
                    { image: "/img/brands/meokgusipo_ice/homepage/products/peach/part1.png", top: 20, left: -7, width: 50 },
                    { image: "/img/brands/meokgusipo_ice/homepage/products/peach/part2.png", bottom: 0, left: 55, width: 50 },
                ]
            },
            {
                image: "/img/brands/meokgusipo_ice/homepage/products/watermelon/product.png",
                detail: "/img/brands/meokgusipo_ice/homepage/products/watermelon/detail.jpg",
                title: "수박",
                backgroundColor: "#f5bdbd",
                parts: [
                    { image: "/img/brands/meokgusipo_ice/homepage/products/watermelon/part1.png", top: 20, left: -7, width: 50 },
                    { image: "/img/brands/meokgusipo_ice/homepage/products/watermelon/part2.png", bottom: 0, left: 55, width: 50 },
                ]
            }
        ]
    },
    {
        id: "meokgusipo",
        logo: "/img/brands/meokgusipo/homepage/logo.png",
        bgImage: "/img/brands/meokgusipo/swiper/background.png",
        fgImage: "/img/brands/meokgusipo/swiper/foreground.png",
        thumbnail: "/img/brands/meokgusipo/swiper/thumbnail.png",
        title: { text: "YUMYUM", color: "#e97237" },
        subTitle: { text: "시리즈소개", color: "#black" },
        inlineComment: [
            { text: "뜨거운 여름", color: "#e97237" },
            { text: "에 잘 어울리는 시원한 액상 ", color: "black" },
            { text: "먹구싶오", color: "#e97237" }
        ],
        content: "richJuicyTaste",
        mainImage: "/img/brands/meokgusipo/homepage/main.png",
        products: [
            {
                image: "/img/brands/meokgusipo/homepage/products/strawberry/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/strawberry/detail.png",
                title: "딸기",
                backgroundColor: "#ffcac5",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/strawberry/part1.png", top: 20, left: -10, width: 45 },
                    { image: "/img/brands/meokgusipo/homepage/products/strawberry/part2.png", top: 55, right: 0, width: 35 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/orange/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/orange/detail.png",
                title: "오렌지",
                backgroundColor: "#ffd26c",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/orange/part1.png", top: 14, left: -3, width: 38 },
                    { image: "/img/brands/meokgusipo/homepage/products/orange/part2.png", top: 55, right: 0, width: 40 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/pineapple/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/pineapple/detail.png",
                title: "파인애플",
                backgroundColor: "#fef7b2",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/pineapple/part1.png", top: 0, left: -25, width: 60 },
                    { image: "/img/brands/meokgusipo/homepage/products/pineapple/part2.png", top: 70, right: -10, width: 45 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/apple/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/apple/detail.png",
                title: "사과",
                backgroundColor: "#d4f2ca",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/apple/part1.png", top: 25, left: -5, width: 40 },
                    { image: "/img/brands/meokgusipo/homepage/products/apple/part2.png", top: 60, right: 0, width: 40 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/pomegranate/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/pomegranate/detail.png",
                title: "석류",
                backgroundColor: "#f4aaad",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/pomegranate/part1.png", top: 20, left: -7, width: 40 },
                    { image: "/img/brands/meokgusipo/homepage/products/pomegranate/part2.png", top: 75, right: -3, width: 45 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/grape/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/grape/detail.png",
                title: "포도",
                backgroundColor: "#f1bfe8",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/grape/part1.png", top: 15, left: -3, width: 47 },
                    { image: "/img/brands/meokgusipo/homepage/products/grape/part2.png", top: 70, right: 5, width: 15 },
                    { image: "/img/brands/meokgusipo/homepage/products/grape/part3.png", top: 85, right: 15, width: 15 },
                ]
            }
        ]
    },
    {
        id: "clean", logo: "/img/brands/clean/homepage/logo.png",
        bgImage: "/img/brands/clean/swiper/background.png",
        fgImage: "/img/brands/clean/swiper/foreground.png",
        thumbnail: "/img/brands/clean/swiper/thumbnail.png",
        title: { text: "neatAndClean", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "돌고 돌아 찾게되는 ", color: "black" },
            { text: "깔끔한, ", color: "black" },
            { text: "액상", color: "black" },
        ],
        content: "cleanLiquidWithoutArtificialScent",
        mainImage: "/img/brands/clean/homepage/main.png",
        products: [
            {
                image: "/img/brands/clean/homepage/products/neatAndUnscented/product.png",
                detail: "/img/brands/clean/homepage/products/neatAndUnscented/detail.jpg",
                title: "무향",
                backgroundColor: "#e5ddd0",
                parts: [
                    { image: "/img/brands/clean/homepage/products/neatAndUnscented/part1.png", top: 9, left: 0, width: 100 },

                ]
            },
            {
                image: "/img/brands/clean/homepage/products/NeatIced/product.png",
                detail: "/img/brands/clean/homepage/products/NeatIced/detail.jpg",
                title: "아이스",
                backgroundColor: "#f3f0ed",
                parts: [
                    { image: "/img/brands/clean/homepage/products/NeatIced/part1.png", top: 20, left: -5, width: 45 },
                    { image: "/img/brands/clean/homepage/products/NeatIced/part2.png", top: 50, right: 6, width: 35 },
                ]
            }

        ]
    },
    {
        id: "romance",
        logo: "/img/brands/romance/homepage/logo.png",
        bgImage: "/img/brands/romance/swiper/background.png",
        fgImage: "/img/brands/romance/swiper/foreground.png",
        thumbnail: "/img/brands/romance/swiper/thumbnail.png",
        title: { text: "romance", color: "#483c54" },
        subTitle: { text: "시리즈소개", color: "#483c54" },
        inlineComment: [
            { text: "비교할 수 없는 ", color: "black" },
            { text: "깊은 풍미, ", color: "black" },
            { text: "연초액상 로망시리즈", color: "black" },
        ],
        content: "bestBalancedTobacco",
        mainImage: "/img/brands/romance/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/romance/homepage/products/vanillaTobaco/product.png",
                detail: "/img/brands/romance/homepage/products/vanillaTobaco/detail.jpg",
                title: "바닐라 토바코",
                backgroundColor: "#e5ddd0",
                parts: [
                    { image: "/img/brands/romance/homepage/products/vanillaTobaco/part1.png", top: 20, left: -10, width: 65 },
                    { image: "/img/brands/romance/homepage/products/vanillaTobaco/part2.png", top: 30, right: 6, width: 35 },
                ]
            },
            {
                image: "/img/brands/romance/homepage/products/tobaco/product.png",
                detail: "/img/brands/romance/homepage/products/tobaco/detail.jpg",
                title: "토바코",
                backgroundColor: "#f3f0ed",
                parts: [
                    { image: "/img/brands/romance/homepage/products/tobaco/part1.png", top: 20, left: -5, width: 45 },
                    { image: "/img/brands/romance/homepage/products/tobaco/part2.png", top: 50, right: 6, width: 35 },
                ]
            },
            {
                image: "/img/brands/romance/homepage/products/mentholTobaco/product.png",
                detail: "/img/brands/romance/homepage/products/mentholTobaco/detail.jpg",
                title: "멘솔 토바코",
                backgroundColor: "#e9e8df",
                parts: [
                    { image: "/img/brands/romance/homepage/products/mentholTobaco/part1.png", top: 20, left: -1, width: 45 },
                    { image: "/img/brands/romance/homepage/products/mentholTobaco/part2.png", top: 45, right: -7, width: 55 },
                ]
            },

        ]
    },
    {
        id: "snowman",
        logo: "/img/brands/snowman/homepage/logo.png",
        bgImage: "/img/brands/snowman/swiper/background.png",
        fgImage: "/img/brands/snowman/swiper/foreground.png",
        thumbnail: "/img/brands/snowman/swiper/thumbnail.png",
        title: { text: "snowman", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "한겨울에 쌓인 ", color: "black" },
            { text: "소복한 눈처럼, ", color: "black" },
            { text: "시원한 쿨링감", color: "black" },
        ],
        content: "coolAndRefreshing",
        mainImage: "/img/brands/snowman/homepage/main.png",
        products: [
            {
                image: "/img/brands/snowman/homepage/products/plum/product.png",
                detail: "/img/brands/snowman/homepage/products/plum/detail.jpg",
                title: "자두샷",
                backgroundColor: "#f9c3d1",
                parts: [
                    { image: "/img/brands/snowman/homepage/products/plum/part1.png", top: 20, left: -10, width: 50 },
                    { image: "/img/brands/snowman/homepage/products/plum/part2.png", top: 55, right: -1, width: 50 },
                ]
            },
            {
                image: "/img/brands/snowman/homepage/products/peachMango/product.png",
                detail: "/img/brands/snowman/homepage/products/peachMango/detail.jpg",
                title: "피치망고샷",
                backgroundColor: "#ffddc3",
                parts: [
                    { image: "/img/brands/snowman/homepage/products/peachMango/part1.png", top: 20, left: -5, width: 45 },
                    { image: "/img/brands/snowman/homepage/products/peachMango/part2.png", top: 55, right: 0, width: 45 },
                ]
            },
            {
                image: "/img/brands/snowman/homepage/products/lime/product.png",
                detail: "/img/brands/snowman/homepage/products/lime/detail.jpg",
                title: "라임샷",
                backgroundColor: "#e9f7f9",
                parts: [
                    { image: "/img/brands/snowman/homepage/products/lime/part1.png", top: 20, left: 2, width: 60 },
                    { image: "/img/brands/snowman/homepage/products/lime/part2.png", top: 50, right: -7, width: 55 },
                ]
            },
            {
                image: "/img/brands/snowman/homepage/products/greenGrape/product.png",
                detail: "/img/brands/snowman/homepage/products/greenGrape/detail.jpg",
                title: "청포도샷",
                backgroundColor: "#bee3c6",
                parts: [
                    { image: "/img/brands/snowman/homepage/products/greenGrape/part1.png", top: 5, left: -10, width: 65 },
                    { image: "/img/brands/snowman/homepage/products/greenGrape/part2.png", top: 45, right: -7, width: 55 },
                ]
            },
            {
                image: "/img/brands/snowman/homepage/products/citron/product.png",
                detail: "/img/brands/snowman/homepage/products/citron/detail.jpg",
                title: "유자샷",
                backgroundColor: "#f6e8b6",
                parts: [
                    { image: "/img/brands/snowman/homepage/products/citron/part1.png", top: 20, left: -1, width: 45 },
                    { image: "/img/brands/snowman/homepage/products/citron/part2.png", top: 55, right: -7, width: 45 },
                ]
            }

        ]
    },
    {
        id: "kkongkkong",
        logo: "/img/brands/kkongkkong/homepage/logo.png",
        bgImage: "/img/brands/kkongkkong/swiper/background.png",
        fgImage: "/img/brands/kkongkkong/swiper/foreground.png",
        thumbnail: "/img/brands/kkongkkong/swiper/thumbnail.png",
        title: { text: "snowmanMunch", color: "black" },
        subTitle: { text: "시리즈소개", color: "#69b9ff" },
        inlineComment: [
            { text: "쿨링감 ", color: "#69b9ff" },
            { text: "업그레이드 ", color: "black" },
            { text: "스노우맨 꽁꽁", color: "#69b9ff" },
        ],
        content: "coolAndCooling",
        mainImage: "/img/brands/kkongkkong/homepage/main.png",
        products: [
            {
                image: "/img/brands/kkongkkong/homepage/products/peach/product.png",
                detail: "/img/brands/kkongkkong/homepage/products/peach/detail.png",
                title: "복숭아꽁꽁",
                backgroundColor: "#fff2f8",
                parts: [
                    { image: "/img/brands/kkongkkong/homepage/products/peach/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/kkongkkong/homepage/products/peach/part2.png", top: 55, right: 2, width: 55 },
                ]
            },
            {
                image: "/img/brands/kkongkkong/homepage/products/apple/product.png",
                detail: "/img/brands/kkongkkong/homepage/products/apple/detail.png",
                title: "사과꽁꽁",
                backgroundColor: "#fffee6",
                parts: [
                    { image: "/img/brands/kkongkkong/homepage/products/apple/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/kkongkkong/homepage/products/apple/part2.png", top: 55, right: 2, width: 45 },
                ]
            },
            {
                image: "/img/brands/kkongkkong/homepage/products/watermelon/product.png",
                detail: "/img/brands/kkongkkong/homepage/products/watermelon/detail.png",
                title: "수박꽁꽁",
                backgroundColor: "#f1fff3",
                parts: [
                    { image: "/img/brands/kkongkkong/homepage/products/watermelon/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/kkongkkong/homepage/products/watermelon/part2.png", top: 55, right: 1, width: 55 },
                ]
            },
            {
                image: "/img/brands/kkongkkong/homepage/products/grapefruit/product.png",
                detail: "/img/brands/kkongkkong/homepage/products/grapefruit/detail.png",
                title: "자몽꽁꽁",
                backgroundColor: "#ffe5e1",
                parts: [
                    { image: "/img/brands/kkongkkong/homepage/products/grapefruit/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/kkongkkong/homepage/products/grapefruit/part2.png", top: 55, right: -2, width: 55 },
                ]
            },
            {
                image: "/img/brands/kkongkkong/homepage/products/cherry/product.png",
                detail: "/img/brands/kkongkkong/homepage/products/cherry/detail.png",
                title: "체리꽁꽁",
                backgroundColor: "#ffe9f2",
                parts: [
                    { image: "/img/brands/kkongkkong/homepage/products/cherry/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/kkongkkong/homepage/products/cherry/part2.png", top: 55, right: 5, width: 35 },
                ]
            },

        ]
    },
    {
        id: "simkoong",
        logo: "/img/brands/simkoong/homepage/logo.png",
        bgImage: "/img/brands/simkoong/swiper/background.png",
        fgImage: "/img/brands/simkoong/swiper/foreground.png",
        thumbnail: "/img/brands/simkoong/swiper/thumbnail.png",
        title: { text: "simkoong", color: "black" },
        subTitle: { text: "시리즈소개", color: "#ff8894" },
        inlineComment: [
            { text: "가슴 뛰게 ", color: "#ff8894" },
            { text: "맛드는 맛 ", color: "black" },
            { text: "심쿵시리즈", color: "#ff8894" },
        ],
        content: "easyToGetIntoWithASoftCooling",
        mainImage: "/img/brands/simkoong/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/simkoong/homepage/products/coffee/product.png",
                detail: "/img/brands/simkoong/homepage/products/coffee/detail.png",
                title: "커피",
                backgroundColor: "#eed3bb",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/coffee/part1.png", top: 25, left: -2, width: 110 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/lemon/product.png",
                detail: "/img/brands/simkoong/homepage/products/lemon/detail.png",
                title: "레몬",
                backgroundColor: "#fffbe9",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/lemon/part1.png", top: 20, left: -2, width: 50 },
                    { image: "/img/brands/simkoong/homepage/products/lemon/part2.png", top: 50, right: -4, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/mango/product.png",
                detail: "/img/brands/simkoong/homepage/products/mango/detail.png",
                title: "망고",
                backgroundColor: "#ffebd9",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/mango/part1.png", top: 15, left: -2, width: 55 },
                    { image: "/img/brands/simkoong/homepage/products/mango/part2.png", top: 55, right: -3, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/menthol/product.png",
                detail: "/img/brands/simkoong/homepage/products/menthol/detail.png",
                title: "멘솔",
                backgroundColor: "#d7edff",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/menthol/part1.png", top: 17, left: -4, width: 55 },
                    { image: "/img/brands/simkoong/homepage/products/menthol/part2.png", top: 55, right: 0, width: 50 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/mix/product.png",
                detail: "/img/brands/simkoong/homepage/products/mix/detail.png",
                title: "믹스",
                backgroundColor: "#f0d4ea",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/mix/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/simkoong/homepage/products/mix/part2.png", top: 55, right: 5, width: 35 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/peach/product.png",
                detail: "/img/brands/simkoong/homepage/products/peach/detail.png",
                title: "피치",
                backgroundColor: "#ffedf3",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/peach/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/simkoong/homepage/products/peach/part2.png", top: 52, right: 0, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/plum/product.png",
                detail: "/img/brands/simkoong/homepage/products/plum/detail.png",
                title: "자두",
                backgroundColor: "#ffe6ee",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/plum/part1.png", top: 17, left: -4, width: 45 },
                    { image: "/img/brands/simkoong/homepage/products/plum/part2.png", top: 55, right: 2, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/pomegranate/product.png",
                detail: "/img/brands/simkoong/homepage/products/pomegranate/detail.png",
                title: "석류",
                backgroundColor: "#ffe2e3",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/pomegranate/part1.png", top: 20, left: -4, width: 50 },
                    { image: "/img/brands/simkoong/homepage/products/pomegranate/part2.png", top: 58, right: 0, width: 55 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/siga/product.png",
                detail: "/img/brands/simkoong/homepage/products/siga/detail.png",
                title: "시가",
                backgroundColor: "#dbc1b3",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/siga/part1.png", top: 20, left: -2, width: 95 },

                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/tabaco/product.png",
                detail: "/img/brands/simkoong/homepage/products/tabaco/detail.png",
                title: "연초",
                backgroundColor: "#f5e4d5",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/tabaco/part1.png", top: 20, left: -2, width: 95 },

                ]
            },

        ]
    },
    {
        id: "simkoong_plus",
        logo: "/img/brands/simkoong_plus/homepage/logo.png",
        bgImage: "/img/brands/simkoong_plus/swiper/background.png",
        fgImage: "/img/brands/simkoong_plus/swiper/foreground.png",
        thumbnail: "/img/brands/simkoong_plus/swiper/thumbnail.png",
        title: { text: "simkoongPlus", color: "black" },
        subTitle: { text: "시리즈소개", color: "#ff8894" },
        inlineComment: [
            { text: "맛과 쿨링 ", color: "black" },
            { text: "모두 잡은 ", color: "black" },
            { text: "깔끔한 데일리 액상", color: "black" },
        ],
        content: "easyToStartWithSimkoongPlus",
        mainImage: "/img/brands/simkoong_plus/homepage/main.png",
        products: [
            {
                image: "/img/brands/simkoong_plus/homepage/products/gold/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/gold/detail.jpg",
                title: "골드",
                backgroundColor: "#f3f2cd",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/gold/part1.png", top: 46, left: 3, width: 100 },
                    { image: "/img/brands/simkoong_plus/homepage/products/gold/part2.png", top: 9, left: -7, width: 135 },
                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/banana/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/banana/detail.jpg",
                title: "나나",
                backgroundColor: "#fcf3c9",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/banana/part2.png", top: 9, left: -7, width: 135 },
                    { image: "/img/brands/simkoong_plus/homepage/products/banana/part1.png", top: 22, left: 0, width: 100 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/power/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/power/detail.jpg",
                title: "파워",
                backgroundColor: "#e7f8f9",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/power/part2.png", top: 17, left: -5, width: 105 },
                    { image: "/img/brands/simkoong_plus/homepage/products/power/part1.png", top: 45, left: -20, width: 140 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/lime/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/lime/detail.jpg",
                title: "라임",
                backgroundColor: "#e7f8e1",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/lime/part2.png", top: 11, left: -7, width: 135 },
                    { image: "/img/brands/simkoong_plus/homepage/products/lime/part1.png", top: 29, left: 0, width: 95 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/melon/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/melon/detail.png",
                title: "멜론",
                backgroundColor: "#f0f5d1",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/melon/part2.png", top: 11, left: -5, width: 105 },
                    { image: "/img/brands/simkoong_plus/homepage/products/melon/part1.png", top: 17, left: -3, width: 110 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/aloe/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/aloe/detail.png",
                title: "알로",
                backgroundColor: "#d5f3cd",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/aloe/part2.png", top: 17, left: -5, width: 105 },
                    { image: "/img/brands/simkoong_plus/homepage/products/aloe/part1.png", top: 29, left: -1, width: 100 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/mint/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/mint/detail.jpg",
                title: "민트",
                backgroundColor: "#cdf3dc",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/mint/part2.png", top: 17, left: -5, width: 125 },
                    { image: "/img/brands/simkoong_plus/homepage/products/mint/part1.png", top: 45, left: -22, width: 130 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/greenTea/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/greenTea/detail.jpg",
                title: "녹차",
                backgroundColor: "#f4f2d0",
                parts: [

                    { image: "/img/brands/simkoong_plus/homepage/products/greenTea/part1.png", top: 6, left: -4, width: 125 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/grape/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/grape/detail.jpg",
                title: "포도",
                backgroundColor: "#edeefb",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/grape/part2.png", top: 17, left: -5, width: 105 },
                    { image: "/img/brands/simkoong_plus/homepage/products/grape/part1.png", top: 49, left: -5, width: 105 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/mocha/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/mocha/detail.png",
                title: "모카",
                backgroundColor: "transparent",
                parts: [

                    { image: "/img/brands/simkoong_plus/homepage/products/mocha/part1.png", top: 10, left: -4, width: 124 },

                ]
            },
            {
                image: "/img/brands/simkoong_plus/homepage/products/pineapple/product.png",
                detail: "/img/brands/simkoong_plus/homepage/products/pineapple/detail.jpg",
                title: "파인",
                backgroundColor: "#fbe9c6",
                parts: [
                    { image: "/img/brands/simkoong_plus/homepage/products/pineapple/part2.png", top: 17, left: -5, width: 105 },
                    { image: "/img/brands/simkoong_plus/homepage/products/pineapple/part1.png", top: 31, left: -24, width: 125 },

                ]
            },

        ]

    },
    {
        id: "mfs",
        logo: "/img/brands/mfs/homepage/logo.png",
        bgImage: "/img/brands/mfs/swiper/background.png",
        fgImage: "/img/brands/mfs/swiper/foreground.png",
        thumbnail: "/img/brands/mfs/swiper/thumbnail.png",
        title: { text: "mfs", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "기본에 충실한 ", color: "black" },
            { text: ", 기본에서도 ", color: "black" },
            { text: "TOP", color: "black" },
        ],
        content: "thisIsTheOriginalTobaccoFlavored",
        mainImage: "/img/brands/mfs/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/mfs/homepage/products/menthol/product.png",
                detail: "/img/brands/mfs/homepage/products/menthol/detail.jpg",
                title: "Menthol",
                backgroundColor: "#9faeb8",
                parts: [
                    { image: "/img/brands/mfs/homepage/products/menthol/part1.png", top: 9, left: -1, width: 102 },


                ]
            },
            {
                image: "/img/brands/mfs/homepage/products/ry4/product.png",
                detail: "/img/brands/mfs/homepage/products/ry4/detail.jpg",
                title: "RY4",
                backgroundColor: "#f3f0ed",
                parts: [
                    { image: "/img/brands/mfs/homepage/products/ry4/part1.png", top: 9, left: 1, width: 102 },

                ]
            }

        ]
    },
    {
        id: "dessert",
        logo: "/img/brands/dessert/homepage/logo.png",
        bgImage: "/img/brands/dessert/swiper/background.png",
        fgImage: "/img/brands/dessert/swiper/foreground.png",
        thumbnail: "/img/brands/dessert/swiper/thumbnail.png",
        title: { text: "dessert", color: "#ffb5c8" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "디저트처럼 ", color: "black" },
            { text: "달콤하고 ", color: "black" },
            { text: "상큼한 매력", color: "black" },
        ],
        content: "sweetAndRefreshing",
        mainImage: "/img/brands/dessert/homepage/main.png",
        products: [
            {
                image: "/img/brands/dessert/homepage/products/fruits/product.png",
                detail: "/img/brands/dessert/homepage/products/fruits/detail.jpg",
                title: "Frults",
                backgroundColor: "#dcfb82",
                parts: [
                    { image: "/img/brands/dessert/homepage/products/fruits/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/dessert/homepage/products/fruits/part2.png", top: 55, right: 0, width: 50 },
                ]
            },
            {
                image: "/img/brands/dessert/homepage/products/peach/product.png",
                detail: "/img/brands/dessert/homepage/products/peach/detail.jpg",
                title: "Peach",
                backgroundColor: "#f8d7d5",
                parts: [
                    { image: "/img/brands/dessert/homepage/products/peach/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/dessert/homepage/products/peach/part2.png", top: 55, right: 0, width: 50 },
                ]
            },
            {
                image: "/img/brands/dessert/homepage/products/pome/product.png",
                detail: "/img/brands/dessert/homepage/products/pome/detail.jpg",
                title: "Pome",
                backgroundColor: "#fb5d82",
                parts: [
                    { image: "/img/brands/dessert/homepage/products/pome/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/dessert/homepage/products/pome/part2.png", top: 65, right: -3, width: 50 },
                ]
            }

        ]
    },

    {
        id: "ame",
        logo: "/img/brands/ame/homepage/logo.png",
        bgImage: "/img/brands/ame/swiper/background.png",
        fgImage: "/img/brands/ame/swiper/foreground.png",
        thumbnail: "/img/brands/ame/swiper/thumbnail.png",
        title: { text: "ame", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "퀄리티가 다른 ", color: "black" },
            { text: "근본 프리미엄 액상 ", color: "black" },

        ],
        content: "spearmintAndPeppermint",
        mainImage: "/img/brands/ame/homepage/main.png",
        products: [
            {
                image: "/img/brands/ame/homepage/products/icePeper/product.png",
                detail: "/img/brands/ame/homepage/products/icePeper/detail.jpg",
                title: "아이스페퍼",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/ame/homepage/products/icePeper/part1.png", top: 9, left: 0, width: 100 },

                ]
            },
            {
                image: "/img/brands/ame/homepage/products/originalTobacco/product.png",
                detail: "/img/brands/ame/homepage/products/originalTobacco/detail.jpg",
                title: "오리지널타바코",
                backgroundColor: "transperent",
                parts: [
                    { image: "/img/brands/ame/homepage/products/originalTobacco/part1.png", top: 9, left: 0, width: 100 },

                ]
            }

        ]
    },
    {
        id: "genius",
        logo: "/img/brands/genius/homepage/logo.png",
        bgImage: "/img/brands/genius/swiper/background.png",
        fgImage: "/img/brands/genius/swiper/foreground.png",
        thumbnail: "/img/brands/genius/swiper/thumbnail.png",
        title: { text: "geniusBlack", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "연초 액상의 근본, ", color: "black" },
            { text: "1세대 연초액상", color: "black" },
            { text: "지니어스", color: "black" },
        ],
        content: "perfectlyBlends",
        mainImage: "/img/brands/genius/homepage/main.png",
        products: [
            {
                image: "/img/brands/genius/homepage/products/black/product.png",
                detail: "/img/brands/genius/homepage/products/black/detail.jpg",
                title: "블랙",
                backgroundColor: "#dcfb82",
                parts: [

                    { image: "/img/brands/genius/homepage/products/black/part1.png", top: 9, left: -10, width: 110 },

                ]
            },
            {
                image: "/img/brands/genius/homepage/products/gold/product.png",
                detail: "/img/brands/genius/homepage/products/gold/detail.jpg",
                title: "골드",
                backgroundColor: "#f8d7d5",
                parts: [

                    { image: "/img/brands/genius/homepage/products/gold/part1.png", top: 8, left: -10, width: 110 },

                ]
            }

        ]
    },
    {
        id: "mov",
        logo: "/img/brands/mov/homepage/logo.png",
        bgImage: "/img/brands/mov/swiper/background.png",
        fgImage: "/img/brands/mov/swiper/foreground.png",
        thumbnail: "/img/brands/mov/swiper/thumbnail.png",
        title: { text: "mov", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "던힐 프로스트를, ", color: "black" },
            { text: "떠올리게 하는", color: "black" },
            { text: " 연초액상", color: "black" },
        ],
        content: "remindsYouOfDunhillFrost",
        mainImage: "/img/brands/mov/homepage/main.png",
        products: [
            {
                image: "/img/brands/mov/homepage/products/frostbite/product.png",
                detail: "/img/brands/mov/homepage/products/frostbite/detail.jpg",
                title: "FROSTBITE",
                backgroundColor: "#dcfb82",
                parts: [

                    { image: "/img/brands/mov/homepage/products/frostbite/part1.png", top: 5.5, left: -3, width: 110 },

                ]
            }
        ]
    },
    {
        id: "naple",
        logo: "/img/brands/naple/homepage/logo.png",
        bgImage: "/img/brands/naple/swiper/background.png",
        fgImage: "/img/brands/naple/swiper/foreground.png",
        thumbnail: "/img/brands/naple/swiper/thumbnail.png",
        title: { text: "napleDessert", color: "#b37225" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "고소하고, ", color: "black" },
            { text: "크리미한", color: "black" },
            { text: " 디저트 한 입", color: "black" },
        ],
        content: "mouthfulOfsavoryAndCreamy",
        mainImage: "/img/brands/naple/homepage/main.png",
        products: [
            {
                image: "/img/brands/naple/homepage/products/peanutPecanCream/product.png",
                detail: "/img/brands/naple/homepage/products/peanutPecanCream/detail.jpg",
                title: "피넛피칸크림",
                backgroundColor: "transperent",
                parts: [

                    { image: "/img/brands/naple/homepage/products/peanutPecanCream/part1.png", top: 9, left: 0, width: 100 },

                ]
            },
            {
                image: "/img/brands/naple/homepage/products/roastPeanut/product.png",
                detail: "/img/brands/naple/homepage/products/roastPeanut/detail.jpg",
                title: "로스트피넛",
                backgroundColor: "transperent",
                parts: [

                    { image: "/img/brands/naple/homepage/products/roastPeanut/part1.png", top: 9, left: -1, width: 107.5 },

                ]
            }
        ]

    },
    {
        id: "vermont",
        logo: "/img/brands/vermont/homepage/logo.png",
        bgImage: "/img/brands/vermont/swiper/background.png",
        fgImage: "/img/brands/vermont/swiper/foreground.png",
        thumbnail: "/img/brands/vermont/swiper/thumbnail.png",
        title: { text: "vermont", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "과일맛을", color: "black" },
            { text: " 제대로 ", color: "black" },
            { text: "표현해 낸", color: "black" },
            { text: " 액상", color: "black" },
        ],
        content: "modernAndSophisticated",
        mainImage: "/img/brands/vermont/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/vermont/homepage/products/appleSherbet/product.png",
                detail: "/img/brands/vermont/homepage/products/appleSherbet/detail.jpg",
                title: "애플샤벳",
                backgroundColor: "#ffe6e6",
                parts: [
                    { image: "/img/brands/vermont/homepage/products/appleSherbet/part1.png", top: 20, left: 0, width: 40 },
                    { image: "/img/brands/vermont/homepage/products/appleSherbet/part2.png", top: 60, left: 60, width: 40 },



                ]
            },
            {
                image: "/img/brands/vermont/homepage/products/passionFruit/product.png",
                detail: "/img/brands/vermont/homepage/products/passionFruit/detail.jpg",
                title: "패션후르츠",
                backgroundColor: "#fff8d9",
                parts: [
                    { image: "/img/brands/vermont/homepage/products/passionFruit/part1.png", top: 20, left: 0, width: 40 },
                    { image: "/img/brands/vermont/homepage/products/passionFruit/part2.png", top: 60, left: 60, width: 40 },



                ]
            },
            {
                image: "/img/brands/vermont/homepage/products/7up/product.png",
                detail: "/img/brands/vermont/homepage/products/7up/detail.jpg",
                title: "7UP",
                backgroundColor: "#edffed",
                parts: [
                    { image: "/img/brands/vermont/homepage/products/7up/part1.png", top: 30, left: 0, width: 40 },
                    { image: "/img/brands/vermont/homepage/products/7up/part2.png", top: 60, left: 60, width: 40 },


                ]
            },
            {
                image: "/img/brands/vermont/homepage/products/blackberry/product.png",
                detail: "/img/brands/vermont/homepage/products/blackberry/detail.jpg",
                title: "블랙베리",
                backgroundColor: "#e6eeff",
                parts: [
                    { image: "/img/brands/vermont/homepage/products/blackberry/part1.png", top: 30, left: 0, width: 60 },
                    { image: "/img/brands/vermont/homepage/products/blackberry/part2.png", top: 60, left: 60, width: 40 },


                ]
            },
            {
                image: "/img/brands/vermont/homepage/products/richrich/product.png",
                detail: "/img/brands/vermont/homepage/products/richrich/detail.jpg",
                title: "리치리치",
                backgroundColor: "#f2e2ff",
                parts: [
                    { image: "/img/brands/vermont/homepage/products/richrich/part1.png", top: 20, left: 0, width: 50 },
                    { image: "/img/brands/vermont/homepage/products/richrich/part2.png", top: 60, left: 60, width: 55 },

                ]
            },
            {
                image: "/img/brands/vermont/homepage/products/creaf/product.png",
                detail: "/img/brands/vermont/homepage/products/creaf/detail.jpg",
                title: "크리프",
                backgroundColor: "#eadccf",
                parts: [
                    { image: "/img/brands/vermont/homepage/products/creaf/part2.png", top: 8, left: 1, width: 95 },
                    { image: "/img/brands/vermont/homepage/products/creaf/part1.png", top: 25, left: 0, width: 105 },


                ]
            },
        ]
    },
    {
        id: "vermont_mod",
        logo: "/img/brands/vermont_mod/homepage/logo.png",
        bgImage: "/img/brands/vermont_mod/swiper/background.png",
        fgImage: "/img/brands/vermont_mod/swiper/foreground.png",
        thumbnail: "/img/brands/vermont_mod/swiper/thumbnail.png",
        title: { text: "vermont_mod", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "과일맛을", color: "black" },
            { text: " 제대로 ", color: "black" },
            { text: "표현해 낸 ", color: "black" },
            { text: "액상", color: "black" },
        ],
        content: "modernAndSophisticated",
        mainImage: "/img/brands/vermont_mod/homepage/main.png",
        products: [
            {
                image: "/img/brands/vermont_mod/homepage/products/appleSherbet/product.png",
                detail: "/img/brands/vermont_mod/homepage/products/appleSherbet/detail.jpg",
                title: "애플샤벳",
                backgroundColor: "#ffe9e9",
                parts: [
                    { image: "/img/brands/vermont_mod/homepage/products/appleSherbet/part1.png", top: 20, left: 0, width: 40 },
                    { image: "/img/brands/vermont_mod/homepage/products/appleSherbet/part2.png", top: 60, left: 60, width: 40 },
                ]
            },
            {
                image: "/img/brands/vermont_mod/homepage/products/yuja/product.png",
                detail: "/img/brands/vermont_mod/homepage/products/yuja/detail.jpg",
                title: "유자",
                backgroundColor: "#ffe8b8",
                parts: [
                    { image: "/img/brands/vermont_mod/homepage/products/yuja/part1.png", top: 20, left: 0, width: 50 },
                    { image: "/img/brands/vermont_mod/homepage/products/yuja/part2.png", top: 60, left: 55, width: 45 },
                ]
            },
            {
                image: "/img/brands/vermont_mod/homepage/products/passionFruit/product.png",
                detail: "/img/brands/vermont_mod/homepage/products/passionFruit/detail.jpg",
                title: "패션후르츠",
                backgroundColor: "#fff8d9",
                parts: [
                    { image: "/img/brands/vermont_mod/homepage/products/passionFruit/part1.png", top: 20, left: 0, width: 50 },
                    { image: "/img/brands/vermont_mod/homepage/products/passionFruit/part2.png", top: 45, left: 45, width: 50 },



                ]
            },
            {
                image: "/img/brands/vermont_mod/homepage/products/litchiAloe/product.png",
                detail: "/img/brands/vermont_mod/homepage/products/litchiAloe/detail.jpg",
                title: "리치알로에",
                backgroundColor: "#e8f4ff",
                parts: [
                    { image: "/img/brands/vermont_mod/homepage/products/litchiAloe/part1.png", top: 30, left: 0, width: 49 },
                    { image: "/img/brands/vermont_mod/homepage/products/litchiAloe/part2.png", top: 60, left: 50, width: 50 },


                ]
            },
            {
                image: "/img/brands/vermont_mod/homepage/products/blackberry/product.png",
                detail: "/img/brands/vermont_mod/homepage/products/blackberry/detail.jpg",
                title: "블랙베리",
                backgroundColor: "#d7deff",
                parts: [
                    { image: "/img/brands/vermont_mod/homepage/products/blackberry/part1.png", top: 15, left: 0, width: 50 },
                    { image: "/img/brands/vermont_mod/homepage/products/blackberry/part2.png", top: 60, left: 60, width: 40 },


                ]
            }
        ]
    },
    {
        id: "2percent",
        logo: "/img/brands/2percent/homepage/logo.png",
        bgImage: "/img/brands/2percent/swiper/background.png",
        fgImage: "/img/brands/2percent/swiper/foreground.png",
        thumbnail: "/img/brands/2percent/swiper/thumbnail.png",
        title: { text: "2percent", color: "#ffaea1" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "은은한 과즙", color: "#ffaea1" },
            { text: "의 단맛과 ", color: "black" },
            { text: "쿨링감이 만났다", color: "black" },
        ],
        content: "freshAndRefreshing",
        mainImage: "/img/brands/2percent/homepage/main.png",
        products: [
            {
                image: "/img/brands/2percent/homepage/products/greenGrape/product.png",
                detail: "/img/brands/2percent/homepage/products/greenGrape/detail.jpg",
                title: "청포도",
                backgroundColor: "#fff2f0",
                parts: [
                    { image: "/img/brands/2percent/homepage/products/greenGrape/part1.png", top: 20, left: -12, width: 100 },
                    { image: "/img/brands/2percent/homepage/products/greenGrape/part2.png", top: 75, left: 3, width: 75 },

                ]
            },
            {
                image: "/img/brands/2percent/homepage/products/peach/product.png",
                detail: "/img/brands/2percent/homepage/products/peach/detail.jpg",
                title: "복숭아",
                backgroundColor: "#f7f9ed",
                parts: [
                    { image: "/img/brands/2percent/homepage/products/peach/part1.png", top: 25, left: -5, width: 100 },
                    { image: "/img/brands/2percent/homepage/products/greenGrape/part2.png", top: 75, left: 3, width: 75 },
                ]
            },
            {
                image: "/img/brands/2percent/homepage/products/greenApple/product.png",
                detail: "/img/brands/2percent/homepage/products/greenApple/detail.jpg",
                title: "청사과",
                backgroundColor: "#edfaed",
                parts: [
                    { image: "/img/brands/2percent/homepage/products/greenApple/part1.png", top: 35, left: -10, width: 120 },
                    { image: "/img/brands/2percent/homepage/products/greenGrape/part2.png", top: 75, left: 3, width: 75 },
                ]
            }
        ]
    },
    {
        id: "toktok",
        logo: "/img/brands/toktok/homepage/logo.png",
        bgImage: "/img/brands/toktok/swiper/background.png",
        fgImage: "/img/brands/toktok/swiper/foreground.png",
        thumbnail: "/img/brands/toktok/swiper/thumbnail.png",
        title: { text: "toktok", color: "#ff4800" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "입안 가득 ", color: "#ff8a00" },
            { text: "진짜 과즙을 마시는듯한", color: "#ff4800" },
            { text: " 새콤 달콤한 과즙이 ", color: "black" },
            { text: "톡톡 터지는 맛", color: "black" },
        ],
        content: "drinkingSodaWithAnAttractive",
        mainImage: "/img/brands/toktok/homepage/main.png",
        products: [
            {
                image: "/img/brands/toktok/homepage/products/grapefruit/product.png",
                detail: "/img/brands/toktok/homepage/products/grapefruit/detail.jpg",
                title: "자몽",
                backgroundColor: "#ff4800",
                parts: [
                    { image: "/img/brands/toktok/homepage/products/grapefruit/part1.png", top: 20, left: -10, width: 55 },
                    { image: "/img/brands/toktok/homepage/products/grapefruit/part2.png", top: 55, left: 45, width: 60 },
                ]
            },
            {
                image: "/img/brands/toktok/homepage/products/lemon/product.png",
                detail: "/img/brands/toktok/homepage/products/lemon/detail.jpg",
                title: "레몬",
                backgroundColor: "#2fa7ea",
                parts: [
                    { image: "/img/brands/toktok/homepage/products/lemon/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/toktok/homepage/products/lemon/part2.png", top: 50, left: 55, width: 60 },

                ]
            }
        ]

    },
    {
        id: "sparkling",
        logo: "/img/brands/sparkling/homepage/logo.png",
        bgImage: "/img/brands/sparkling/swiper/background.png",
        fgImage: "/img/brands/sparkling/swiper/foreground.png",
        thumbnail: "/img/brands/sparkling/swiper/thumbnail.png",
        title: { text: "sparkling", color: "#ff8a00" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "과즙", color: "#ff8a00" },
            { text: "이", color: "black" },
            { text: " 톡톡 터지는 ", color: "#ff8a00" },
            { text: "상콤 달콤함과 시원함 쿨링감이 조화로운 맛", color: "black" },
        ],
        content: "sparkingDrinkSoda",
        mainImage: "/img/brands/sparkling/homepage/main.png",
        products: [
            {
                image: "/img/brands/sparkling/homepage/products/orange/product.png",
                detail: "/img/brands/sparkling/homepage/products/orange/detail.jpg",
                title: "오렌지",
                backgroundColor: "transparent",
                parts: [
                    { image: "/img/brands/sparkling/homepage/products/orange/part2.png", top: 8, left: -1, width: 101 },
                    { image: "/img/brands/sparkling/homepage/products/orange/part1.png", top: 20, left: -10, width: 115 },


                ]
            },
            {
                image: "/img/brands/sparkling/homepage/products/melon/product.png",
                detail: "/img/brands/sparkling/homepage/products/melon/detail.jpg",
                title: "메론",
                backgroundColor: "transparent",
                parts: [

                    { image: "/img/brands/sparkling/homepage/products/melon/part2.png", top: 8, left: -1, width: 101 },
                    { image: "/img/brands/sparkling/homepage/products/melon/part1.png", top: 20, left: -10, width: 115 },

                ]
            },
            {
                image: "/img/brands/sparkling/homepage/products/grape/product.png",
                detail: "/img/brands/sparkling/homepage/products/grape/detail.jpg",
                title: "포도",
                backgroundColor: "transparent",
                parts: [

                    { image: "/img/brands/sparkling/homepage/products/grape/part2.png", top: 8, left: -1, width: 101 },
                    { image: "/img/brands/sparkling/homepage/products/grape/part1.png", top: 20, left: -10, width: 115 },

                ]
            }
        ]
    }

];



export const brands2 = [
    {
        id: "meokgusipo",
        logo: "/img/brands/meokgusipo/homepage/logo.png",
        bgImage: "/img/brands/meokgusipo/swiper/background.png",
        fgImage: "/img/brands/meokgusipo/swiper/foreground.png",
        thumbnail: "/img/brands/meokgusipo/swiper/thumbnail.png",
        title: { text: "YUMYUM", color: "#e97237" },
        subTitle: { text: "시리즈소개", color: "#black" },
        inlineComment: [
            { text: "뜨거운 여름", color: "#e97237" },
            { text: "에 잘 어울리는 시원한 액상 ", color: "black" },
            { text: "먹구싶오", color: "#e97237" }
        ],
        content: "richJuicyTaste",
        mainImage: "/img/brands/meokgusipo/homepage/main.png",
        products: [
            {
                image: "/img/brands/meokgusipo/homepage/products/strawberry/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/strawberry/detail.png",
                title: "딸기",
                backgroundColor: "#ffcac5",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/strawberry/part1.png", top: 20, left: -10, width: 45 },
                    { image: "/img/brands/meokgusipo/homepage/products/strawberry/part2.png", top: 55, right: 0, width: 35 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/orange/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/orange/detail.png",
                title: "오렌지",
                backgroundColor: "#ffd26c",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/orange/part1.png", top: 14, left: -3, width: 38 },
                    { image: "/img/brands/meokgusipo/homepage/products/orange/part2.png", top: 55, right: 0, width: 40 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/pineapple/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/pineapple/detail.png",
                title: "파인애플",
                backgroundColor: "#fef7b2",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/pineapple/part1.png", top: 0, left: -25, width: 60 },
                    { image: "/img/brands/meokgusipo/homepage/products/pineapple/part2.png", top: 70, right: -10, width: 45 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/apple/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/apple/detail.png",
                title: "사과",
                backgroundColor: "#d4f2ca",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/apple/part1.png", top: 25, left: -5, width: 40 },
                    { image: "/img/brands/meokgusipo/homepage/products/apple/part2.png", top: 60, right: 0, width: 40 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/pomegranate/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/pomegranate/detail.png",
                title: "석류",
                backgroundColor: "#f4aaad",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/pomegranate/part1.png", top: 20, left: -7, width: 40 },
                    { image: "/img/brands/meokgusipo/homepage/products/pomegranate/part2.png", top: 75, right: -3, width: 45 },
                ]
            },
            {
                image: "/img/brands/meokgusipo/homepage/products/grape/product.png",
                detail: "/img/brands/meokgusipo/homepage/products/grape/detail.png",
                title: "포도",
                backgroundColor: "#f1bfe8",
                parts: [
                    { image: "/img/brands/meokgusipo/homepage/products/grape/part1.png", top: 15, left: -3, width: 47 },
                    { image: "/img/brands/meokgusipo/homepage/products/grape/part2.png", top: 70, right: 5, width: 15 },
                    { image: "/img/brands/meokgusipo/homepage/products/grape/part3.png", top: 85, right: 15, width: 15 },
                ]
            }
        ]
    },
    {
        id: "clean", logo: "/img/brands/clean/homepage/logo.png",
        bgImage: "/img/brands/clean/swiper/background.png",
        fgImage: "/img/brands/clean/swiper/foreground.png",
        thumbnail: "/img/brands/clean/swiper/thumbnail.png",
        title: { text: "neatAndClean", color: "black" },
        subTitle: { text: "시리즈소개", color: "black" },
        inlineComment: [
            { text: "돌고 돌아 찾게되는 ", color: "black" },
            { text: "깔끔한, ", color: "black" },
            { text: "액상", color: "black" },
        ],
        content: "cleanLiquidWithoutArtificialScent",
        mainImage: "/img/brands/clean/homepage/main.png",
        products: [
            {
                image: "/img/brands/clean/homepage/products/neatAndUnscented/product.png",
                detail: "/img/brands/clean/homepage/products/neatAndUnscented/detail.jpg",
                title: "무향",
                backgroundColor: "#e5ddd0",
                parts: [
                    { image: "/img/brands/clean/homepage/products/neatAndUnscented/part1.png", top: 9, left: 0, width: 100 },

                ]
            },
            {
                image: "/img/brands/clean/homepage/products/NeatIced/product.png",
                detail: "/img/brands/clean/homepage/products/NeatIced/detail.jpg",
                title: "아이스",
                backgroundColor: "#f3f0ed",
                parts: [
                    { image: "/img/brands/clean/homepage/products/NeatIced/part1.png", top: 20, left: -5, width: 45 },
                    { image: "/img/brands/clean/homepage/products/NeatIced/part2.png", top: 50, right: 6, width: 35 },
                ]
            }

        ]
    },
    {
        id: "romance",
        logo: "/img/brands/romance/homepage/logo.png",
        bgImage: "/img/brands/romance/swiper/background.png",
        fgImage: "/img/brands/romance/swiper/foreground.png",
        thumbnail: "/img/brands/romance/swiper/thumbnail.png",
        title: { text: "romance", color: "#483c54" },
        subTitle: { text: "시리즈소개", color: "#483c54" },
        inlineComment: [
            { text: "비교할 수 없는 ", color: "black" },
            { text: "깊은 풍미, ", color: "black" },
            { text: "연초액상 로망시리즈", color: "black" },
        ],
        content: "bestBalancedTobacco",
        mainImage: "/img/brands/romance/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/romance/homepage/products/vanillaTobaco/product.png",
                detail: "/img/brands/romance/homepage/products/vanillaTobaco/detail.jpg",
                title: "바닐라 토바코",
                backgroundColor: "#e5ddd0",
                parts: [
                    { image: "/img/brands/romance/homepage/products/vanillaTobaco/part1.png", top: 20, left: -10, width: 65 },
                    { image: "/img/brands/romance/homepage/products/vanillaTobaco/part2.png", top: 30, right: 6, width: 35 },
                ]
            },
            {
                image: "/img/brands/romance/homepage/products/tobaco/product.png",
                detail: "/img/brands/romance/homepage/products/tobaco/detail.jpg",
                title: "토바코",
                backgroundColor: "#f3f0ed",
                parts: [
                    { image: "/img/brands/romance/homepage/products/tobaco/part1.png", top: 20, left: -5, width: 45 },
                    { image: "/img/brands/romance/homepage/products/tobaco/part2.png", top: 50, right: 6, width: 35 },
                ]
            },
            {
                image: "/img/brands/romance/homepage/products/mentholTobaco/product.png",
                detail: "/img/brands/romance/homepage/products/mentholTobaco/detail.jpg",
                title: "멘솔 토바코",
                backgroundColor: "#e9e8df",
                parts: [
                    { image: "/img/brands/romance/homepage/products/mentholTobaco/part1.png", top: 20, left: -1, width: 45 },
                    { image: "/img/brands/romance/homepage/products/mentholTobaco/part2.png", top: 45, right: -7, width: 55 },
                ]
            },

        ]
    },
    {
        id: "simkoong",
        logo: "/img/brands/simkoong/homepage/logo.png",
        bgImage: "/img/brands/simkoong/swiper/background.png",
        fgImage: "/img/brands/simkoong/swiper/foreground.png",
        thumbnail: "/img/brands/simkoong/swiper/thumbnail.png",
        title: { text: "simkoong", color: "black" },
        subTitle: { text: "시리즈소개", color: "#ff8894" },
        inlineComment: [
            { text: "가슴 뛰게 ", color: "#ff8894" },
            { text: "맛드는 맛 ", color: "black" },
            { text: "심쿵시리즈", color: "#ff8894" },
        ],
        content: "easyToGetIntoWithASoftCooling",
        mainImage: "/img/brands/simkoong/homepage/main.jpg",
        products: [
            {
                image: "/img/brands/simkoong/homepage/products/coffee/product.png",
                detail: "/img/brands/simkoong/homepage/products/coffee/detail.png",
                title: "커피",
                backgroundColor: "#eed3bb",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/coffee/part1.png", top: 25, left: -2, width: 110 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/lemon/product.png",
                detail: "/img/brands/simkoong/homepage/products/lemon/detail.png",
                title: "레몬",
                backgroundColor: "#fffbe9",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/lemon/part1.png", top: 20, left: -2, width: 50 },
                    { image: "/img/brands/simkoong/homepage/products/lemon/part2.png", top: 50, right: -4, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/mango/product.png",
                detail: "/img/brands/simkoong/homepage/products/mango/detail.png",
                title: "망고",
                backgroundColor: "#ffebd9",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/mango/part1.png", top: 15, left: -2, width: 55 },
                    { image: "/img/brands/simkoong/homepage/products/mango/part2.png", top: 55, right: -3, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/menthol/product.png",
                detail: "/img/brands/simkoong/homepage/products/menthol/detail.png",
                title: "멘솔",
                backgroundColor: "#d7edff",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/menthol/part1.png", top: 17, left: -4, width: 55 },
                    { image: "/img/brands/simkoong/homepage/products/menthol/part2.png", top: 55, right: 0, width: 50 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/mix/product.png",
                detail: "/img/brands/simkoong/homepage/products/mix/detail.png",
                title: "믹스",
                backgroundColor: "#f0d4ea",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/mix/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/simkoong/homepage/products/mix/part2.png", top: 55, right: 5, width: 35 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/peach/product.png",
                detail: "/img/brands/simkoong/homepage/products/peach/detail.png",
                title: "피치",
                backgroundColor: "#ffedf3",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/peach/part1.png", top: 20, left: -2, width: 45 },
                    { image: "/img/brands/simkoong/homepage/products/peach/part2.png", top: 52, right: 0, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/plum/product.png",
                detail: "/img/brands/simkoong/homepage/products/plum/detail.png",
                title: "자두",
                backgroundColor: "#ffe6ee",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/plum/part1.png", top: 17, left: -4, width: 45 },
                    { image: "/img/brands/simkoong/homepage/products/plum/part2.png", top: 55, right: 2, width: 45 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/pomegranate/product.png",
                detail: "/img/brands/simkoong/homepage/products/pomegranate/detail.png",
                title: "석류",
                backgroundColor: "#ffe2e3",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/pomegranate/part1.png", top: 20, left: -4, width: 50 },
                    { image: "/img/brands/simkoong/homepage/products/pomegranate/part2.png", top: 58, right: 0, width: 55 },
                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/siga/product.png",
                detail: "/img/brands/simkoong/homepage/products/siga/detail.png",
                title: "시가",
                backgroundColor: "#dbc1b3",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/siga/part1.png", top: 20, left: -2, width: 95 },

                ]
            },
            {
                image: "/img/brands/simkoong/homepage/products/tabaco/product.png",
                detail: "/img/brands/simkoong/homepage/products/tabaco/detail.png",
                title: "연초",
                backgroundColor: "#f5e4d5",
                parts: [
                    { image: "/img/brands/simkoong/homepage/products/tabaco/part1.png", top: 20, left: -2, width: 95 },

                ]
            },

        ]
    }

];